<template>
  <q-form-item
    :prop="element.key"
    :label="element.caption"
  >
    <persian-date-picker
      v-if="this.$store.state.session.cultureName === 'fa'"
      v-model="model[element.key]"
      :disabled="element.disabled"
      :editable="true"
    />
    <q-date-picker
      v-else
      v-model="model[element.key]"
      :disabled="element.disabled"
      :type="element.dateType"
      value-format="yyyy-MM-dd"
    />
  </q-form-item>
</template>

<script>
  import elementGeneratorMixin from "./elementGeneratorMixin";

  export default {
    name: "DatePickerItem",
    mixins: [elementGeneratorMixin],
  }
</script>

<style scoped>

</style>